module.exports =
  data: ->
    current_user: Session.current_user
    filters: {}

  methods:
    loadNotificationsOptionsSuccess: (data) ->
      # Commita as mudanças para o state do central store
      @$store.commit 'loadNotifications', data.notifications if @load_notifications

    loadNotificationsOptions: ->
      @notifications_resource.index(@loadNotificationsOptionsSuccess, @unknownError, params: @filters )

  computed:
    notifications: ->
      @$store.getters.notificationsList

    load_notifications: ->
      @$store.getters.notificationsCount == 0

  created: ->
    @notifications_resource = new NotificationsResource()
    if @load_notifications
      @loadNotificationsOptions()



// WEBPACK FOOTER //
// ./src/mixins/notifications.coffee